<div class="d-flex justify-content-between align-items-center {{class}}">
    <syslink-input-text class="w-100" [labelMode]="name ? 'floating' : 'hidden'" [name]="name || ''" [model]="model" (modelChange)="modelUpdate.emit($event)"></syslink-input-text>
    <i *ngIf="canShowIcon" class="fa-solid fa-flag mx-2" role="button" (click)="onTranslationsBtnClicked.emit()"></i>
</div>